import useAnchorSectionObserver from '~hooks/useAnchorSectionObserver';
import { CATEGORY_TAB_HEIGHT, SEARCH_HOME_TITLE_HEIGHT } from '~constants/common';
import { PASS_SECTION_KEY } from '~constants/pass';

import type { PassSectionKey } from '~types/pass';

const PASS_HEADER_HEIGHT = 64;
const THRESHOLD = SEARCH_HOME_TITLE_HEIGHT + CATEGORY_TAB_HEIGHT + PASS_HEADER_HEIGHT;

const useAnchorPassSectionObserver = () => {
  const {
    subscribe,
    scrollTo: originScrollTo,
    inViewSectionKey,
  } = useAnchorSectionObserver<PassSectionKey>({
    sectionKeys: Object.values(PASS_SECTION_KEY),
    threshold: THRESHOLD,
  });

  const scrollTo = (sectionKey: PassSectionKey) => {
    if (sectionKey === PASS_SECTION_KEY.ALL) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    originScrollTo(sectionKey);
  };

  return { subscribe, scrollTo, inViewSectionKey };
};

export default useAnchorPassSectionObserver;
